import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'amfe-flexible/index.js'
import moment from 'moment'
import 'remixicon/fonts/remixicon.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2'
import { Toast } from 'vant-green';
import { CascadeSelect,Uploader  } from 'vant-green';
Vue.use(CascadeSelect);
Vue.use(Uploader );
Vue.use(Toast);
Vue.use(VueClipboard)
Vue.use(ElementUI);
Vue.prototype.$moment = moment
Vue.config.productionTip = false

Vue.use(Vant)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
